const performanceCookieCategory = "2";

// Preference center accessibility fixes
let onetrustPreferenceCenterTrigger = null;
let onetrustPreferenceCenterScrollPosition = null;
let onetrustPreferenceCenterNativeFocus = null;
let onetrustPreferenceCenterFocusPatchTimeout = null;

function storeOneTrustPreferenceCenterScrollPosition() {
  if (onetrustPreferenceCenterScrollPosition) return;

  onetrustPreferenceCenterScrollPosition = {
    left: window.scrollX,
    top: window.scrollY,
  };
}

// Temporarily prevent third-party close focus from scrolling the page
function preventOneTrustPreferenceCenterFocusScroll() {
  if (!onetrustPreferenceCenterNativeFocus) {
    onetrustPreferenceCenterNativeFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (...args) {
      if (args.length > 0)
        return onetrustPreferenceCenterNativeFocus.apply(this, args);

      try {
        return onetrustPreferenceCenterNativeFocus.call(this, {
          preventScroll: true,
        });
      } catch (error) {
        return onetrustPreferenceCenterNativeFocus.call(this);
      }
    };
  }

  window.clearTimeout(onetrustPreferenceCenterFocusPatchTimeout);
  onetrustPreferenceCenterFocusPatchTimeout = window.setTimeout(function () {
    HTMLElement.prototype.focus = onetrustPreferenceCenterNativeFocus;
    onetrustPreferenceCenterNativeFocus = null;
  }, 100);
}

function handleOneTrustPreferenceCenterEscapeKey(event) {
  if (event.key !== "Escape" || !onetrustPreferenceCenterTrigger) return;

  storeOneTrustPreferenceCenterScrollPosition();
  preventOneTrustPreferenceCenterFocusScroll();
  focusOneTrustPreferenceCenterTrigger();
}

// Fix for accessibility issue: Modal is closed, focus is not returned to trigger
function focusOneTrustPreferenceCenterTrigger() {
  const trigger = onetrustPreferenceCenterTrigger;
  const scrollPosition = onetrustPreferenceCenterScrollPosition || {
    left: window.scrollX,
    top: window.scrollY,
  };

  onetrustPreferenceCenterTrigger = null;
  onetrustPreferenceCenterScrollPosition = null;
  document.removeEventListener(
    "keydown",
    handleOneTrustPreferenceCenterEscapeKey,
    true,
  );

  if (
    !trigger ||
    !document.contains(trigger) ||
    typeof trigger.focus !== "function"
  )
    return;

  function restoreFocusAndScroll() {
    try {
      trigger.focus({ preventScroll: true });
    } catch (error) {
      trigger.focus();
    }

    window.scrollTo(scrollPosition.left, scrollPosition.top);
  }

  window.setTimeout(function () {
    restoreFocusAndScroll();
    window.setTimeout(restoreFocusAndScroll, 50);
  }, 0);
}

// Bind Onetrust close button modal
function bindOneTrustPreferenceCenterCloseButtons() {
  const closeButtons = document.querySelectorAll(
    "#close-pc-btn-handler, .onetrust-close-btn-handler",
  );

  closeButtons.forEach(function (closeButton) {
    if (closeButton.dataset.focusReturnBound === "true") return;

    closeButton.dataset.focusReturnBound = "true";
    closeButton.addEventListener(
      "keydown",
      function (event) {
        if (
          event.key !== "Enter" &&
          event.key !== " " &&
          event.key !== "Spacebar"
        )
          return;

        storeOneTrustPreferenceCenterScrollPosition();
        preventOneTrustPreferenceCenterFocusScroll();
      },
      true,
    );
    closeButton.addEventListener(
      "click",
      function () {
        storeOneTrustPreferenceCenterScrollPosition();
        preventOneTrustPreferenceCenterFocusScroll();
        focusOneTrustPreferenceCenterTrigger();
      },
      true,
    );
  });
}

// Look for links with anchor tag: #onetrust-modal
function initOnetrustLink() {
  try {
    const onetrustLinks = document.querySelectorAll(
      'a[href="#onetrust-modal"]',
    );
    if (onetrustLinks && onetrustLinks.length > 0) {
      onetrustLinks.forEach(function (onetrustLink) {
        onetrustLink.setAttribute("role", "button");
        onetrustLink.setAttribute("aria-haspopup", "dialog");

        if (onetrustLink.dataset.onetrustModalBound === "true") return;

        onetrustLink.dataset.onetrustModalBound = "true";
        onetrustLink.addEventListener("keydown", function (event) {
          if (event.key !== " " && event.key !== "Spacebar") return;

          event.preventDefault();
          event.currentTarget.click();
        });

        onetrustLink.addEventListener("click", function (event) {
          const oneTrustApi = window.OneTrust || window.Optanon;

          event.preventDefault();

          if (
            oneTrustApi &&
            typeof oneTrustApi.ToggleInfoDisplay === "function"
          ) {
            onetrustPreferenceCenterTrigger = event.currentTarget;
            document.addEventListener(
              "keydown",
              handleOneTrustPreferenceCenterEscapeKey,
              true,
            );
            window.addEventListener(
              "OneTrustPCLoaded",
              bindOneTrustPreferenceCenterCloseButtons,
              { once: true },
            );
            oneTrustApi.ToggleInfoDisplay();
          } else {
            console.warn("OneTrust is not defined");
          }
        });
      });
    }
  } catch (error) {
    console.error("Error in initOnetrustLink:", error);
  }
}

// Consent and tracking functionality
// Initiate Onetrust global variable
function waitForOneTrust() {
  try {
    let attempts = 0;
    const interval = setInterval(function () {
      if (hasOneTrustLoaded() || attempts > 100) {
        clearInterval(interval);
      }
      attempts++;
    }, 100);
  } catch (error) {
    console.error("Error in waitForOneTrust:", error);
  }
}

function hasOneTrustLoaded() {
  try {
    if (typeof window.OnetrustActiveGroups === "string") {
      optanonWrapper();
      window.OptanonWrapper = optanonWrapper;
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error in hasOneTrustLoaded:", error);
    return false;
  }
}

// Set the Shopify tracking consent
function sendConsent(trackingConsent) {
  try {
    const defaultConsent = {
      analytics: trackingConsent,
      marketing: trackingConsent,
      preferences: trackingConsent,
    };

    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(defaultConsent, () => {
        console.log("trackingConsent:", trackingConsent);
        console.log(
          "currentVisitorConsent:",
          window.Shopify.customerPrivacy.currentVisitorConsent(),
        );
        console.log("OptanonActiveGroups", window.OptanonActiveGroups);
        if (window.dataLayer) {
          window.dataLayer.push({
            consent_status: trackingConsent,
          });
        }
      });
    } else {
      console.warn("Shopify Customer Privacy API not available");
    }
  } catch (error) {
    console.error("Error in sendConsent:", error);
  }
}

// Initiate Shopify Consent API
function optanonWrapper() {
  try {
    const trackingConsent = window.OnetrustActiveGroups.includes(
      performanceCookieCategory,
    );
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error) {
          console.error("Error loading Shopify features:", error);
        } else {
          sendConsent(trackingConsent);
        }
      },
    );
  } catch (error) {
    console.error("Error in optanonWrapper:", error);
  }
}

// Update social media consent
function checkOnConsent(status) {
  try {
    if (status) {
      if (typeof fbq !== "undefined") fbqPixelConsentManage("grant");
      if (typeof ttq !== "undefined") ttqPixelConsentManage("grant");
      if (window.dtrum) dynatraceConsentManage(true);
    } else {
      if (typeof fbq !== "undefined") fbqPixelConsentManage("revoke");
      if (typeof ttq !== "undefined") ttqPixelConsentManage("revoke");
      if (window.dtrum) dynatraceConsentManage(false);
    }
  } catch (error) {
    console.error("Error in checkOnConsent:", error);
  }
}

// Example pixel consent management functions
function fbqPixelConsentManage(status) {
  try {
    if (
      typeof fbq !== "undefined" &&
      (status === "revoke" || status === "grant")
    ) {
      window.fbq("consent", status);
      console.log("=> Facebook consent status:", status.toUpperCase());
    }
  } catch (error) {
    console.error("Error in fbqPixelConsentManage:", error);
  }
}

function ttqPixelConsentManage(status) {
  try {
    if (typeof ttq !== "undefined") {
      if (status === "revoke") ttq.revokeConsent();
      if (status === "grant") ttq.grantConsent();
      console.log("=> TikTok consent status:", status.toUpperCase());
    }
  } catch (error) {
    console.error("Error in ttqPixelConsentManage:", error);
  }
}

function dynatraceConsentManage(status) {
  try {
    if (window.dtrum) {
      if (status) {
        window.dtrum.enableSessionReplay(true);
        window.dtrum.enable();
        console.log("=> Dynatrace consent status: ENABLED");
      } else {
        window.dtrum.disableSessionReplay();
        console.log("=> Dynatrace consent status: DISABLED");
      }
    }
  } catch (error) {
    console.error("Error in dynatraceConsentManage:", error);
  }
}

// Initialization
// On initial load, load Shopify Consent Tracking
window.Shopify.loadFeatures(
  [
    {
      name: "consent-tracking-api",
      version: "0.1",
    },
  ],
  (error) => {
    if (error) {
      console.error("Error loading Shopify Consent API:", error);
    } else {
      try {
        // Check if OnetrustActiveGroups exists before using it
        if (
          typeof window.OnetrustActiveGroups === "string" &&
          window.OnetrustActiveGroups
        ) {
          const trackingConsent = window.OnetrustActiveGroups.includes(
            performanceCookieCategory,
          );
          checkOnConsent(trackingConsent);
        } else {
          console.log(
            "OneTrust not yet loaded, will be handled by waitForOneTrust",
          );
          // Default to no consent until OneTrust loads
          checkOnConsent(false);
        }
      } catch (e) {
        console.error("Error during initial consent load:", e);
      }
    }
  },
);

// DOMContentLoaded event
document.addEventListener("DOMContentLoaded", () => {
  try {
    initOnetrustLink();
    waitForOneTrust();
  } catch (error) {
    console.error("Error in DOMContentLoaded handler:", error);
  }
});
